import { render } from "./CardWithBadge.vue?vue&type=template&id=3f37187a"
import script from "./CardWithBadge.vue?vue&type=script&lang=js"
export * from "./CardWithBadge.vue?vue&type=script&lang=js"

import "./CardWithBadge.vue?vue&type=style&index=0&id=3f37187a&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__